import DataTables from "datatables.net-bs4";
import jQuery from "jquery";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

// DataTables();

const datatableBaseOptions = {
  dom: "rtp",
  responsive: true,
  searching: true,
  paging: true,
  info: false,
  language: {
    emptyTable: "La lista dei profili sarà disponibile a breve",
  },
  pageLength: 30,
};

const datatableOptions = {
  ajax: {
    url: "/get_bande_minime/",
    dataSrc: "",
  },
  columnDefs: [
    {
      targets: "_all",
      defaultContent: "-",
    },
  ],
  columns: [
    {
      data: "operatore",
    },
    {
      data: "alias",
    },
    {
      data: "tipo_cliente",
    },
    {
      data: "tecnologia",
    },
    {
      data: "profilo_tecnico",
    },
    {
      data: "down_all",
    },
    {
      data: "down",
    },
    {
      data: "min_down",
    },
    {
      data: "max_down",
    },
    {
      data: "norm_down",
    },
  ],
};

const table = jQuery("#bande-minime").DataTable({
  ...datatableBaseOptions,
  ...datatableOptions,
});

$("#bande-minime thead tr")
  .clone(true)
  .addClass("filters")
  .appendTo("#bande-minime thead");

table
  .columns()
  .eq(0)
  .each((colIdx) => {
    const cell = $(".filters th").eq($(table.column(colIdx).header()).index());
    const title = $(cell).text();
    $(cell).html(`<input type="text" placeholder="cerca..." class="small" />`);

    $("input", $(".filters th").eq($(table.column(colIdx).header()).index()))
      .off("keyup change")
      .on("keyup change", function (e) {
        e.stopPropagation();
        $(this).attr("title", $(this).val());
        const regexr = "({search})";
        table
          .column(colIdx)
          .search(
            this.value !== ""
              ? regexr.replace("{search}", `(((${this.value})))`)
              : "",
            this.value !== "",
            this.value === "",
          )
          .draw();
      });

    $("select", $(".filters th").eq($(table.column(colIdx).header()).index()))
      .off("change")
      .on("change", function () {
        $(this).parents("th").find("input").trigger("change");
      });
  });
